/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { MatchedStatementAnswer } from './MatchedStatementAnswer.js';
import {
    MatchedStatementAnswerFromJSON,
    MatchedStatementAnswerFromJSONTyped,
    MatchedStatementAnswerToJSON,
} from './MatchedStatementAnswer.js';
import type { MatchedStatementSentence } from './MatchedStatementSentence.js';
import {
    MatchedStatementSentenceFromJSON,
    MatchedStatementSentenceFromJSONTyped,
    MatchedStatementSentenceToJSON,
} from './MatchedStatementSentence.js';

/**
 * 
 * @export
 * @interface LedgerStatementMatch
 */
export interface LedgerStatementMatch {
    /**
     * 
     * @type {number}
     * @memberof LedgerStatementMatch
     */
    contactId?: number;
    /**
     * 
     * @type {number}
     * @memberof LedgerStatementMatch
     */
    utteranceId?: number;
    /**
     * 
     * @type {number}
     * @memberof LedgerStatementMatch
     */
    startOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof LedgerStatementMatch
     */
    endOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof LedgerStatementMatch
     */
    score?: number;
    /**
     * 
     * @type {Array<MatchedStatementSentence>}
     * @memberof LedgerStatementMatch
     */
    sentences?: Array<MatchedStatementSentence>;
    /**
     * 
     * @type {MatchedStatementAnswer}
     * @memberof LedgerStatementMatch
     */
    answer?: MatchedStatementAnswer;
}

/**
 * Check if a given object implements the LedgerStatementMatch interface.
 */
export function instanceOfLedgerStatementMatch(value: object): boolean {
    return true;
}

export function LedgerStatementMatchFromJSON(json: any): LedgerStatementMatch {
    return LedgerStatementMatchFromJSONTyped(json, false);
}

export function LedgerStatementMatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): LedgerStatementMatch {
    if (json == null) {
        return json;
    }
    return {
        
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'utteranceId': json['utteranceId'] == null ? undefined : json['utteranceId'],
        'startOffset': json['startOffset'] == null ? undefined : json['startOffset'],
        'endOffset': json['endOffset'] == null ? undefined : json['endOffset'],
        'score': json['score'] == null ? undefined : json['score'],
        'sentences': json['sentences'] == null ? undefined : ((json['sentences'] as Array<any>).map(MatchedStatementSentenceFromJSON)),
        'answer': json['answer'] == null ? undefined : MatchedStatementAnswerFromJSON(json['answer']),
    };
}

export function LedgerStatementMatchToJSON(value?: LedgerStatementMatch | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contactId': value['contactId'],
        'utteranceId': value['utteranceId'],
        'startOffset': value['startOffset'],
        'endOffset': value['endOffset'],
        'score': value['score'],
        'sentences': value['sentences'] == null ? undefined : ((value['sentences'] as Array<any>).map(MatchedStatementSentenceToJSON)),
        'answer': MatchedStatementAnswerToJSON(value['answer']),
    };
}

